/**
 * @flow
 * @relayHash a2d88e2e8b8d42eb204c71155df9f854
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddFormFieldOptionInput = {|
  formFieldId: string,
  name: string,
  value: string,
|};
export type AddFormFieldOptionMutationVariables = {|
  input: AddFormFieldOptionInput
|};
export type AddFormFieldOptionMutationResponse = {|
  +addFormFieldOption: {|
    +formField: {|
      +id: string
    |}
  |}
|};
export type AddFormFieldOptionMutation = {|
  variables: AddFormFieldOptionMutationVariables,
  response: AddFormFieldOptionMutationResponse,
|};
*/


/*
mutation AddFormFieldOptionMutation(
  $input: AddFormFieldOptionInput!
) {
  addFormFieldOption(input: $input) {
    formField {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddFormFieldOptionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addFormFieldOption",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddFormFieldOptionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "formField",
        "storageKey": null,
        "args": null,
        "concreteType": "FormField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddFormFieldOptionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddFormFieldOptionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddFormFieldOptionMutation",
    "id": null,
    "text": "mutation AddFormFieldOptionMutation(\n  $input: AddFormFieldOptionInput!\n) {\n  addFormFieldOption(input: $input) {\n    formField {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cec0f8a4c59f3c6ebde4b52e5c5a8855';
module.exports = node;
